import {DeserializedLeafRule} from "../../slate/Transformation";

export const Rules: {[key: string]: DeserializedLeafRule<HTMLElement>} = {
    "text": {
        isVoid: () => false,
        tagType: () => 'inline',
        match: (element) => element.hasOwnProperty('text'),
        deserialize(el, next) {
            if (el.nodeType === Node.TEXT_NODE && el.textContent.trim() !== '') {
                return {text: el.textContent};
            }
        },
        serialize(node, leaf, next) {
            return leaf;
        },
        render: ({leaf}) => {
            //console.log(node);
            return leaf;
        }
    }
}